import { createCustomEnum } from "./customEnum";

const AutoTidStatusType = createCustomEnum({
	inProgress: {
		name: "in_progress",
		value: "in_progress",
		displayName: "In Progress",
	},
	success: {
		name: "success",
		value: "success",
		displayName: "Success",
	},
	terminated: {
		name: "terminated",
		value: "terminated",
		displayName: "Terminated",
	},
	failed: {
		name: "failed",
		value: "failed",
		displayName: "Failed",
	},
	na: {
		name: "na",
		value: "na",
		displayName: "N/A",
	},
});

export default AutoTidStatusType;
